/**
 * Extracts the session ID from a Jitsi room name.
 * Clinical sessions use the format: session-{sessionId}
 *
 * @param {string} roomName - The full room name from Jitsi conference.
 * @returns {string | null} - The extracted session ID, or null if not a session room.
 */
export function extractSessionId(roomName) {
    if (!roomName) {
        return null;
    }
    // Match pattern: session-{sessionId} (UUID format with hyphens)
    const sessionPattern = /^session-([a-zA-Z0-9-]+)$/;
    const match = roomName.match(sessionPattern);
    if (match && match[1]) {
        return match[1];
    }
    return null;
}
/**
 * Checks if a room name represents a clinical session.
 *
 * @param {string} roomName - The room name to check.
 * @returns {boolean} - True if the room is a clinical session room.
 */
export function isClinicalSessionRoom(roomName) {
    return extractSessionId(roomName) !== null;
}
